(function(){
  if (window.__lfInit) return; window.__lfInit = true;
  var $$ = function(s, r){ return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function init(){
    // gallery: thumbs swap main image
    $$('[data-lf-gallery]').forEach(function(g){
      var img = g.querySelector('[data-lf-main] img');
      $$('[data-lf-thumb]', g).forEach(function(t){
        t.addEventListener('click', function(){
          $$('[data-lf-thumb]', g).forEach(function(x){ x.setAttribute('aria-current', 'false'); });
          t.setAttribute('aria-current', 'true');
          if (img){ img.src = t.dataset.src; img.removeAttribute('srcset'); img.alt = t.dataset.alt || ''; }
        });
      });
    });

    // quantity steppers
    $$('[data-lf-qty]').forEach(function(q){
      var input = q.querySelector('input');
      $$('button', q).forEach(function(b){
        b.addEventListener('click', function(){
          var v = (parseInt(input.value, 10) || 1) + parseInt(b.dataset.d, 10);
          input.value = Math.min(99, Math.max(1, v));
        });
      });
    });

    // variant / bundle radios update the price block and the button price
    $$('[data-lf-buy]').forEach(function(box){
      var now = box.querySelector('[data-lf-price]');
      var was = box.querySelector('[data-lf-compare]');
      var save = box.querySelector('[data-lf-save]');
      var btn = box.querySelector('.lf-atc');
      var atcPrice = box.querySelector('[data-lf-atc-price]');
      $$('input[type="radio"][name="id"]', box).forEach(function(r){
        r.addEventListener('change', function(){
          if (now) now.textContent = r.dataset.price;
          if (was){ was.textContent = r.dataset.compare || ''; was.hidden = !r.dataset.compare; }
          if (save){ save.textContent = r.dataset.save || ''; }
          if (atcPrice){ atcPrice.textContent = r.dataset.price; }
          if (btn){ btn.disabled = r.dataset.available !== 'true'; }
          document.dispatchEvent(new CustomEvent('lf:variant', { detail: r.dataset }));
        });
      });
    });

    // delivery timeline
    var lang = document.documentElement.lang || 'en';
    function fmt(d){ return d.toLocaleDateString(lang, { month: 'short', day: 'numeric' }); }
    function addBiz(n){ var d = new Date(), k = 0; while (k < n){ d.setDate(d.getDate() + 1); if (d.getDay() % 6) k++; } return d; }
    $$('[data-lf-timeline]').forEach(function(t){
      var n = t.dataset.lfTimeline.split(',').map(Number);
      t.querySelector('[data-t0]').textContent = fmt(new Date());
      t.querySelector('[data-t1]').textContent = fmt(addBiz(n[0])) + ' – ' + fmt(addBiz(n[1]));
      t.querySelector('[data-t2]').textContent = fmt(addBiz(n[2])) + ' – ' + fmt(addBiz(n[3]));
    });

    // quote carousel: auto-slides every 4s, dots + swipe; pauses only on real mouse hover
    $$('[data-lf-carousel]').forEach(function(c){
      var slides = $$('[data-lf-slide]', c), dots = $$('[data-lf-dot]', c), i = 0, timer;
      if (slides.length < 2) return;
      slides.forEach(function(s){ s.style.transition = 'opacity .35s ease'; });
      function show(n){
        i = (n + slides.length) % slides.length;
        slides.forEach(function(s, k){ s.hidden = k !== i; s.style.opacity = k === i ? '1' : '0'; });
        dots.forEach(function(d, k){ d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      }
      function start(){ clearInterval(timer); timer = setInterval(function(){ if (!document.hidden) show(i + 1); }, 4000); }
      dots.forEach(function(d, k){ d.addEventListener('click', function(){ show(k); start(); }); });
      c.addEventListener('pointerenter', function(e){ if (e.pointerType === 'mouse') clearInterval(timer); });
      c.addEventListener('pointerleave', function(e){ if (e.pointerType === 'mouse') start(); });
      var x0 = null;
      c.addEventListener('touchstart', function(e){ x0 = e.touches[0].clientX; }, { passive: true });
      c.addEventListener('touchend', function(e){ if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40){ show(i + (dx < 0 ? 1 : -1)); start(); } x0 = null; }, { passive: true });
      show(0); start();
    });

    // sticky add-to-cart after the main button scrolls away
    var sticky = document.querySelector('[data-lf-sticky]');
    var anchor = document.querySelector('#lf-main-form .lf-atc');
    if (sticky && anchor && 'IntersectionObserver' in window){
      new IntersectionObserver(function(e){
        sticky.classList.toggle('is-visible', !e[0].isIntersecting && e[0].boundingClientRect.top < 0);
      }).observe(anchor);
    }
    document.addEventListener('lf:variant', function(e){
      var p = document.querySelector('[data-lf-sticky-price]');
      if (p) p.textContent = e.detail.price;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
